import React from 'react';

const ContactDetails = () => {
  return (
    <section className='section-contact-details section-padding'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-3'>
            <div className='contact-block-wrapper'>
              <div className='block-content-wrapper'>
                <h3>Address</h3>
                <p>
                  <a href='https://maps.app.goo.gl/fDmXPSWxN5R9poSd6' target='_blank' rel='noreferrer'>
                    51/53, Shamshet Street (Chippi Chawl),
                    near Zaveri Bazar,
                    Mumbai, Maharashtra 400002,
                    India
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3'>
            <div className='contact-block-wrapper'>
              <div className='block-content-wrapper'>
                <h3>Email</h3>
                <p>
                  <a href='mailto:info@indiaembroideryco.com'>info@indiaembroideryco.com</a>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3'>
            <div className='contact-block-wrapper'>
              <div className='block-content-wrapper'>
                <h3>Phone</h3>
                <p>
                  <a href='tel:9769327720'>+91 97693 27720</a>
                </p>
              </div>
            </div>
          </div>

          <div className='col-md-3'>
            <div className='contact-block-wrapper'>
              <div className='block-content-wrapper'>
                <h3>Follow us</h3>

                <div className='footer-social-icons'>
                  {/* Facebook */}
                  <a href='https://www.facebook.com' target='_blank' rel='noopener noreferrer'>
                    <div className='social-icon facebook-icon'>
                      <div className='social-icon-bloom'></div>
                      <div className='social-icon-sparkle'>
                        {[...Array(5)].map((_, i) => (
                          <div key={i} className='social-icon-sparkle-line'></div>
                        ))}
                      </div>
                      <svg className='social-icon-shape' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512'>
                        <path d='M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z'></path>
                      </svg>
                    </div>
                  </a>

                  {/* Instagram */}
                  <a href='https://www.instagram.com' target='_blank' rel='noopener noreferrer'>
                    <div className='social-icon instagram-icon'>
                      <div className='social-icon-bloom'></div>
                      <div className='social-icon-sparkle'>
                        {[...Array(5)].map((_, i) => (
                          <div key={i} className='social-icon-sparkle-line'></div>
                        ))}
                      </div>
                      <svg className='social-icon-shape' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                        <path d='M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z'></path> {/* Truncated for brevity */}
                      </svg>
                    </div>
                  </a>

                  {/* Twitter */}
                  <a href='https://www.twitter.com' target='_blank' rel='noopener noreferrer'>
                    <div className='social-icon linkedin-icon'>
                      <div className='social-icon-bloom'></div>
                      <div className='social-icon-sparkle'>
                        {[...Array(5)].map((_, i) => (
                          <div key={i} className='social-icon-sparkle-line'></div>
                        ))}
                      </div>
                      <svg className='social-icon-shape' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'>
                        <path d='M100.28 448H7.4V148.9h92.88zm-46.44-340C24.11 108 0 83.87 0 54.06 0 24.23 24.11 0 53.84 0s53.84 24.23 53.84 54.06c0 29.81-24.11 53.94-53.84 53.94zM447.9 448h-92.68V302.4c0-34.7-12.4-58.4-43.4-58.4-23.7 0-37.8 16-44 31.4-2.3 5.5-2.8 13.2-2.8 20.9V448h-92.68s1.2-241.2 0-266.1h92.68v37.7c12.3-19 34.3-46.1 83.5-46.1 60.9 0 106.6 39.8 106.6 125.2V448z'></path> {/* Truncated for brevity */}
                      </svg>
                    </div>
                  </a>

                  {/* Snapchat / WhatsApp */}
                  <a href='https://www.snapchat.com' target='_blank' rel='noopener noreferrer'>
                    <div className='social-icon whatsapp-icon'>
                      <div className='social-icon-bloom'></div>
                      <div className='social-icon-sparkle'>
                        {[...Array(5)].map((_, i) => (
                          <div key={i} className='social-icon-sparkle-line'></div>
                        ))}
                      </div>
                      <svg className='social-icon-shape' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
                        <path d='M3.50002 12C3.50002 7.30558 7.3056 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C10.3278 20.5 8.77127 20.0182 7.45798 19.1861C7.21357 19.0313 6.91408 18.9899 6.63684 19.0726L3.75769 19.9319L4.84173 17.3953C4.96986 17.0955 4.94379 16.7521 4.77187 16.4751C3.9657 15.176 3.50002 13.6439 3.50002 12ZM12 1.5C6.20103 1.5 1.50002 6.20101 1.50002 12C1.50002 13.8381 1.97316 15.5683 2.80465 17.0727L1.08047 21.107C0.928048 21.4637 0.99561 21.8763 1.25382 22.1657C1.51203 22.4552 1.91432 22.5692 2.28599 22.4582L6.78541 21.1155C8.32245 21.9965 10.1037 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM14.2925 14.1824L12.9783 15.1081C12.3628 14.7575 11.6823 14.2681 10.9997 13.5855C10.2901 12.8759 9.76402 12.1433 9.37612 11.4713L10.2113 10.7624C10.5697 10.4582 10.6678 9.94533 10.447 9.53028L9.38284 7.53028C9.23954 7.26097 8.98116 7.0718 8.68115 7.01654C8.38113 6.96129 8.07231 7.046 7.84247 7.24659L7.52696 7.52195C6.76823 8.18414 6.3195 9.2723 6.69141 10.3741C7.07698 11.5163 7.89983 13.314 9.58552 14.9997C11.3991 16.8133 13.2413 17.5275 14.3186 17.8049C15.1866 18.0283 16.008 17.7288 16.5868 17.2572L17.1783 16.7752C17.4313 16.5691 17.5678 16.2524 17.544 15.9269C17.5201 15.6014 17.3389 15.308 17.0585 15.1409L15.3802 14.1409C15.0412 13.939 14.6152 13.9552 14.2925 14.1824Z'></path> {/* Truncated for brevity */}
                      </svg>
                    </div>
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetails;
